const replaceGDPRVariables = ({ value }: { value: string }): string => {
  // eslint-disable-next-line no-template-curly-in-string
  return value.replaceAll('${GDPR}', '0').replaceAll('${GDPR_CONSENT_755}', '0');
};

const useAdTopData = ({ isMobile }: { isMobile: boolean }) => {
  const shallShowAdTop =
    Boolean(globalThis.gazeta_pl.RTC_V2.adUrl) &&
    Boolean(globalThis.gazeta_pl.RTC_V2.adBinaryUrlDesktop) &&
    Boolean(globalThis.gazeta_pl.RTC_V2.adBinaryUrlMobile);

  return {
    adTopImpression:
      globalThis.gazeta_pl.RTC_V2.adImpression &&
      replaceGDPRVariables({ value: globalThis.gazeta_pl.RTC_V2.adImpression }),
    adTopPicture: isMobile
      ? globalThis.gazeta_pl.RTC_V2.adBinaryUrlMobile
      : globalThis.gazeta_pl.RTC_V2.adBinaryUrlDesktop,
    adTopURL: globalThis.gazeta_pl.RTC_V2.adUrl && replaceGDPRVariables({ value: globalThis.gazeta_pl.RTC_V2.adUrl }),
    shallShowAdTop,
  };
};

export default useAdTopData;
